import { render } from "./hardware-logs-view.vue?vue&type=template&id=4990fed4"
import script from "./hardware-logs-view.vue?vue&type=script&lang=ts"
export * from "./hardware-logs-view.vue?vue&type=script&lang=ts"

import "./hardware-logs-view.vue?vue&type=style&index=0&id=4990fed4&lang=less"
script.render = render

export default script